<div
  class="sb-field sb-select"
  [class.sb-field--disabled]="disabled()"
  [class.sb-field--required]="required()"
  [class.sb-field--help-inside]="showHelpEndInside"
  [class.sb-field--help-outside]="showHelpEndOutside">
  @if (description()) {
  <div class="sb-field__description">{{ description() }}</div>
  }

  <div
    class="sb-field__control-row"
    [class.sb-field__control-row--with-help]="showHelpEndOutside">
    <div
      class="sb-field__control sb-select__control"
      [class.floating-label]="hasFloatingLabel"
      [class.has-value]="hasValue"
      [class.sb-select--active]="isActive">
      <ng-select
        [id]="id()"
        class="sb-select__ng"
        [items]="resolvedItems()"
        [bindLabel]="itemLabelKey"
        [bindValue]="itemValueKey"
        [multiple]="multiple()"
        [clearable]="clearable()"
        [placeholder]="selectPlaceholder"
        [ariaLabel]="ariaLabel() || undefined"
        [disabled]="disabled()"
        [loading]="loading()"
        [searchable]="autocomplete()"
        [addTag]="tagFactory"
        [addTagText]="addTagText()"
        [searchFn]="itemSearchFn"
        [required]="required()"
        [compareWith]="compareWith"
        [ngModel]="value"
        (ngModelChange)="onSelected($event)"
        (search)="onSearch($event)"
        (scrollToEnd)="onScrollToEnd()"
        (open)="onOpen()"
        (close)="onClose()"
        (focus)="onFocus()"
        (blur)="onBlur()">
        @if (imageKey()) {
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          @if (multiple()) {
          <span class="ng-value-icon left" aria-hidden="true" (click)="clear(item)">&times;</span>
          }
          <span class="sb-select__item">
            @if (itemImage(item); as image) {
            <img class="sb-select__image" [src]="image" alt="" />
            }
            <span class="sb-select__item-label">{{ itemLabel(item) }}</span>
          </span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span class="sb-select__item">
            @if (itemImage(item); as image) {
            <img class="sb-select__image" [src]="image" alt="" />
            }
            <span class="sb-select__item-label">{{ itemLabel(item) }}</span>
          </span>
        </ng-template>
        }
      </ng-select>

      @if (hasFloatingLabel) {
      <label class="select-label" [attr.for]="id()">
        {{ label() }}
        @if (required()) {
        <span class="red">*</span>
        }
        @if (showHelpAfterLabel) {
        <app-info-popover
          class="sb-field__help sb-field__help--after-label"
          [info]="helpText"></app-info-popover>
        }
      </label>
      }

      @if (showHelpEndInside) {
      <app-info-popover
        class="sb-field__help sb-field__help--end-inside sb-select__info"
        [info]="helpText"></app-info-popover>
      }

      @if (error()) {
      <div class="bar error-brd sb-field__error">
        <div class="invalid-text">{{ error() }}</div>
      </div>
      }
    </div>
    @if (showHelpEndOutside) {
    <app-info-popover
      class="sb-field__help sb-field__help--end-outside"
      [info]="helpText"></app-info-popover>
    }
  </div>
</div>
